import { render, staticRenderFns } from "./ItemKit.vue?vue&type=template&id=315de6b1&"
import script from "./ItemKit.vue?vue&type=script&lang=js&"
export * from "./ItemKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports